import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { Button, CircularProgress } from "@mui/material";
import * as yup from "yup";
import { useFormik } from "formik";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { sm: "30%", xs: "100%" },
  bgcolor: "background.paper",
  boxShadow: 10,
  p: 2,
  height: "40vh",
  overflow: "auto",
  borderRadius: "16px",
};

const validationSchema = yup.object({
  text: yup
    .string("Post text")
    .min(1, "too short")
    .max(50000, "too long")
    .required("Text is required"),
});

export default function UpdateCommentText({
  handleClose,
  open,
  comment,
  loading,
  handleUpdateComments,
  type = "comment",
}) {
  const formik = useFormik({
    initialValues: {
      text: comment?.text,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (loading) return;
      const callback = () => {
        formik.resetForm();
        handleClose();
      };

      handleUpdateComments(values, callback);
    },
  });

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Paper sx={style} component="form" onSubmit={formik.handleSubmit}>
        <Box
          display="flex"
          flexDirection="column"
          height={1}
          alignItems="center"
          justifyContent="space-between"
        >
          <Box width={1} display="flex" justifyContent="flex-start">
            <Typography
              variant="h6"
              textAlign="start"
              className="pointer"
              onClick={handleClose}
            >
              X
            </Typography>
            <Typography variant="h6" textAlign="center" flexGrow={1}>
              Update {type}
            </Typography>
          </Box>
          <Box width={1} sx={{ my: 2 }}>
            <TextField
              fullWidth
              name="text"
              label={`Text`}
              value={formik.values.text}
              onChange={formik.handleChange}
              variant="standard"
              error={formik.touched.text && Boolean(formik.errors.text)}
              helperText={formik.touched.text && formik.errors.text}
              multiline
              rows={3}
            />
          </Box>

          <Box width={1}>
            <Button
              fullWidth
              size="small"
              variant="contained"
              type="submit"
              disabled={loading}
            >
              {loading ? <CircularProgress size={25} /> : "Update"}
            </Button>
          </Box>
        </Box>
      </Paper>
    </Modal>
  );
}
